// タブ機能の関数
const initTabs = () => {
    const tabContainer = document.querySelector("#step-tabs");
    if (!tabContainer) return;

    const tabButtons = document.querySelectorAll(".js-tabs-button");
    const tabContents = document.querySelectorAll(".js-tabs-content");

    // 最初のタブをデフォルトでアクティブにする
    if (tabContents.length > 0) {
        tabContents[0].dataset.active = "";
    }

    if (tabButtons.length > 0) {
        tabButtons[0].dataset.active = "";
    }

    // 各タブボタンにクリックイベントを設定
    tabButtons.forEach((title, index) => {
        title.addEventListener("click", () => {
            // タブコンテンツの表示/非表示を切り替え
            tabContents.forEach((content, i) => {
                if (i === index) {
                    content.dataset.active = "";
                } else {
                    delete content.dataset.active;
                }
            });

            // タブボタンのアクティブ状態を切り替え
            tabButtons.forEach((btn, i) => {
                if (i === index) {
                    btn.dataset.active = "";
                } else {
                    delete btn.dataset.active;
                }
            });

            // イベントを発火（オプション）
            const customEvent = new CustomEvent("tabChange", {
                detail: { currentPage: index },
            });
            tabContainer.dispatchEvent(customEvent);
        });
    });

    // イベントリスナーを追加する関数
    tabContainer.on = function (eventName, callback) {
        this.addEventListener(eventName, (e) => {
            callback(e.detail);
        });
    };
};

const main = () => {
    if (document.querySelector("#page-flow_of_selling-index") === null) return;

    initTabs();
};

export default main;
